import type { SubTheme } from "@/api/theme/models";
import type { LinkGroup, LicensedThemeMap, CategoryLink } from "@/types/categoryFilters";
import { ProductLineEnum } from "shared-components/interfaces/blank";

export const createGeneralCategoryLinks = (licensedThemes: SubTheme[] = []): LinkGroup[] => {
  const allowedTeams = ["flamengo", "fluminense", "botafogo"];
  const licensedThemeMap: LicensedThemeMap = {};
  const licensedThemeIds: string[] = [];
  const licensedThemeItems: CategoryLink[] = [];

  licensedThemes.forEach((theme) => {
    const themeName = theme.name?.toLowerCase();
    if (themeName && theme.id && allowedTeams.includes(themeName)) {
      licensedThemeMap[themeName] = theme.id;
    }
  });

  allowedTeams.forEach((teamName) => {
    const themeId = licensedThemeMap[teamName];
    if (themeId) {
      licensedThemeIds.push(themeId);

      const displayName = teamName.charAt(0).toUpperCase() + teamName.slice(1);
      licensedThemeItems.push({
        name: displayName,
        url: `themes=${themeId}`,
      });
    }
  });

  return [
    {
      name: "Linhas",
      url: `line=${ProductLineEnum.CASUAL}&line=${ProductLineEnum.ESPORTIVO}`,
      items: [
        {
          name: "Casual",
          url: `line=${ProductLineEnum.CASUAL}`,
        },
        {
          name: "Esportiva",
          url: `line=${ProductLineEnum.ESPORTIVO}`,
        },
      ],
    },
  ];
};

export const masculineCategoryLinks: LinkGroup[] = [
  {
    name: "Roupas",
    url: "public=MASCULINO",
    items: [
      {
        name: "Camisetas",
        url: "public=MASCULINO&model=Camiseta",
      },
      {
        name: "Regatas",
        url: "public=MASCULINO&model=Regata",
      },
      {
        name: "Casacos",
        url: "public=MASCULINO&model=Casaco",
      },
    ],
  },
];

export const feminineCategoryLinks: LinkGroup[] = [
  {
    name: "Roupas",
    url: "public=FEMININO",
    items: [
      {
        name: "Camisetas",
        url: "public=FEMININO&model=Camiseta",
      },
      {
        name: "Croppeds",
        url: "public=FEMININO&model=Cropped",
      },
    ],
  },
];

export const childrenCategoryLinks: LinkGroup[] = [
  {
    name: "Roupas",
    url: "public=INFANTIL",
    items: [
      {
        name: "Camisetas",
        url: "public=INFANTIL&model=Camiseta",
      },
    ],
  },
];
